import events from '@/hooks/events';
import actions from '../constants';

export default {
  useShowDefaultRole: () => events.useSimpleDispatch(actions.SHOW_DEFAULT_ROLE),
  useShowRole: (category, { code }) => events.useDispatchByCode(actions.SHOW_SAVE_ROLE, category, code),
};
